import * as React from 'react';
import { TYPOGRAPHY_SIZE, TypographySize } from 'mm-theme-configuration/dist/consts';
import { css } from 'aphrodite/no-important';
import { SemanticTagDataProps, SemanticTagProps, SemanticTagThemeProps, getStyleBySize } from '../semanticTags/semanticTags.utils';
import { useTheme } from '../../theming/useTheme';

export const H3Component: React.FunctionComponent<SemanticTagProps> = props => {
  const defaultFontSize = TYPOGRAPHY_SIZE.LARGE as TypographySize;
  const { children, fontSizesStyles, styles = [], fontSizeSmall = defaultFontSize, fontSizeMedium = defaultFontSize, fontSizeLarge = defaultFontSize } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, { fontSizeSmall, fontSizeMedium, fontSizeLarge });

  return (
    <h3 className={css(styleBySize, ...styles)}>{children}</h3>
  );
};

const mapThemeProps = (theme: SemanticTagThemeProps) => {
  return {
    fontSizesStyles: theme.fontSizesStyles,
  };
};

export const H3: React.FunctionComponent<SemanticTagDataProps> = props => {
  const { styles, ...additionalProps } = props;
  const themeContext = useTheme(mapThemeProps);
  return <H3Component styles={styles} {...themeContext} {...additionalProps} />;
};
